<template>
	<div class="card-v2" id="availability">
		<header class="margin flex-split gap-16">
			<h2 class="m0">Availability</h2>
			<div v-if="isOwnCalendar && !isStudio" class="flex gap-8">
				<button
					class="btn btn-short"
					@click.self="showA10yDatesModal = !showA10yDatesModal">
					Edit Calendar
				</button>
				<button class="btn btn-util square-32 rel" @click="showA10ySettingsModal = true">
					<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
						<path stroke="#140047" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M10 13.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z"/><path stroke="#004ADB" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9.6 3.45 8.124 2.345a.625.625 0 0 0-.56-.098c-.457.143-.9.327-1.324.548a.625.625 0 0 0-.33.466l-.26 1.824a6.695 6.695 0 0 0-.566.567h0l-1.824.26a.625.625 0 0 0-.466.328 8.074 8.074 0 0 0-.548 1.324.625.625 0 0 0 .097.562L3.449 9.6a6.695 6.695 0 0 0 0 .801h0l-1.105 1.474a.625.625 0 0 0-.097.561c.143.457.326.9.547 1.324a.625.625 0 0 0 .466.328l1.825.261a6.67 6.67 0 0 0 .566.567h0l.261 1.824a.624.624 0 0 0 .328.465c.424.222.867.405 1.323.549a.625.625 0 0 0 .562-.097l1.474-1.106a6.645 6.645 0 0 0 .801 0h0l1.475 1.105a.626.626 0 0 0 .56.098c.457-.144.9-.327 1.324-.548a.626.626 0 0 0 .329-.466l.26-1.824a6.653 6.653 0 0 0 .567-.567h0l1.824-.26a.625.625 0 0 0 .465-.329c.222-.424.406-.866.55-1.323a.625.625 0 0 0-.098-.562l-1.106-1.474a6.647 6.647 0 0 0 0-.801h0l1.106-1.474a.626.626 0 0 0 .097-.561 8.077 8.077 0 0 0-.548-1.324.626.626 0 0 0-.466-.329l-1.824-.26a6.663 6.663 0 0 0-.566-.567h0l-.261-1.824a.625.625 0 0 0-.328-.465 8.079 8.079 0 0 0-1.323-.549.626.626 0 0 0-.562.097L10.4 3.45a6.697 6.697 0 0 0-.802 0h0Z"/>
					</svg>
					<Tooltip arrow="bottom center">Edit default rolling availability settings</Tooltip>
				</button>
			</div>
		</header>
		<AvailabilityCalendar :user="userId" class="border-top pt-24 rel z-2"/>
		<CalendarLegend :showJobs="true" :showAvailabilities="showAvailabilities" :isOwnCalendar="isOwnCalendar" class="mt-24 rel z-1"/>
		<div v-if="isOwnCalendar" class="flex-center mt-24">
			<SyncCalendarButton class="btn btn-link" icon="arrows-clockwise">
				Sync Calendar
			</SyncCalendarButton>
		</div>
		
		<!-- Modals -->
		<!-- AvailabilityEditModal is inside <calendar> -->
		<AvailabilitySettingsModal v-model="showA10ySettingsModal"/>
		<AvailabilityDatesModal v-model="showA10yDatesModal"/>
	</div>
</template>

<script>
import AvailabilityCalendar from '@/components/calendars/AvailabilityCalendar';
import AvailabilitySettingsModal from '@/components/availability/AvailabilitySettingsModal';
import AvailabilityDatesModal from '@/components/availability/AvailabilityDatesModal';
import SyncCalendarButton from '@/components/calendars/SyncCalendarButton';
import CalendarLegend from '@/components/calendars/CalendarLegend';
import helpers from '@/mixins/helpers';

export default {
	name: 'CardAvailability',
	mixins: [helpers],
	components: {
		CalendarLegend,
		SyncCalendarButton,
		AvailabilityCalendar,
		AvailabilityDatesModal,
		AvailabilitySettingsModal,
	},
	data() {
		return {
			showA10yDatesModal: false,
			showA10ySettingsModal: false,
			showA10yEditModal: false,
		};
	},
	computed: {
		showAvailabilities() {
			if (this.isStudio && this.isOwnCalendar) {
				return false;
			}

			return true;
		},
		userId() {
			return this.$isLoggedIn ? this.$currentProfile?.userId : null;
		},
		isOwnCalendar() {
			const userId = this.$activeUser?.id;
			return !!(userId && userId === this.$currentProfile.userId) || this.$route.name == 'dashboard';
		},
	},
}
</script>
